import React, { useContext } from 'react'
import SugarcubeContext from 'apps/SugarcubeContext'
import DashboardContainer from 'containers/dashboard/DashboardContainer.jsx'
import KioskLandingContainer from 'containers/KioskLandingContainer'

require('./DashboardPage.scss')

const DashboardPage = () => {
    const { isKiosk } = useContext(SugarcubeContext)

    if (isKiosk) {
        return <KioskLandingContainer />
    }
    return (
        <div id="DashboardPage">
            <DashboardContainer />)
        </div>
    )
}
export default DashboardPage
